import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {formatNumber} from "../../../common/util/numberFormatter";
import Popover from "../../../common/components/popover/popover.js";
import {getFlightSuffix} from "../../../common/util/unitConverter";


const ImpactSection = ({ fetchedImpact }) => {
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    const treeMetric = treeGrowthYears && <span className="translate-dynamic font-etihad-important"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as </span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
    const passengerDistance = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.flightsImpact?.passengerDistance?.value))
    const passengerDistanceUnit = fetchedImpact && !fetchedImpact.error && getFlightSuffix(fetchedImpact.flightsImpact?.passengerDistance?.unit.toLowerCase());
    const numberOfPassengers = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.flightsImpact?.numberOfPassengers.value);
    
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()

    return (
        <div id="content" className="py-6">
            <div className="container massonry-container font-etihad-important">
                <div className="mb-3 center mw-800px translate-dynamic">
                    <h3 className="font-bold color-secondary">Reduce global carbon emissions</h3>
                    <h5 className="color-secondary font-etihad mb-3">We’ve partnered with CarbonClick to let you offset your carbon emissions when you fly. You’ll help to fund gold standard projects that significantly reduce the amount of CO<sub>2</sub> in the atmosphere. Together, we are fighting climate change.</h5>
                </div>
                <div className="row m-0 impact justify-center">
                    <div className="one col-6 d-grid">
                        <div className="my-3 shadow w-100 br-12">
                            <div className="br-top-12 img-cover impact-all w-100"></div>
                            <div className="my-3 mx-4">
                                <h4 className='color-secondary font-medium'>{passengerDistance}</h4>
                                <span className="color-secondary translate-dynamic">{`Carbon neutral air (${passengerDistanceUnit})`}</span>
                            </div>
                        </div>
                    </div>

                    <div className="two col-6 d-grid">
                        <div className="my-3 shadow w-100 br-12">
                            <div className="br-top-12 impact-community img-cover-top w-100"></div>
                            <div className="my-3 mx-4">
                                <h4 className='color-secondary font-medium'>{numberOfPassengers}</h4>
                                <span className="color-secondary translate-dynamic">Climate friendly travellers</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row m-0 impact justify-center">

                    <div className="three col-5 d-grid">
                        <div className="my-3 shadow w-100 br-12">
                            <div className="br-top-12 img-cover impact-CO2 w-100"></div>
                            <div className="my-3 mx-4">
                                <h4 className='color-secondary font-medium'>{carbonOffsetImpact}</h4>
                                <span className="color-secondary translate-dynamic">Kgs of CO<sub>2</sub> offset</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-5 d-grid">
                        <div className="my-3 shadow w-100 br-12">
                            <div className="br-top-12 img-cover impact-trees w-100"></div>
                                <div className="my-3 mx-4">
                                    <h4 className='color-secondary font-medium'>{fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value)}</h4>
                                    <p><span className="color-secondary font-etihad-important">Trees</span>
                                        <Popover content={treeMetric} className="translate-dynamic font-etihad-important">
                                            <svg className="color-secondary flip-when-right-to-left-language v-align-top mx-2" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 32 32" width="20">
                                                <g id="Atom/-Icon/-Functional-icon/-Digital-components/-Information" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="functional_information">
                                                        <path d="M16,1.74999379 L16,1.74999379 C23.020807,1.7827614 28.9808828,6.90410581 30.07,13.84 C30.676292,17.9376817 29.4733875,22.0967102 26.7733549,25.2381126 C24.0733224,28.3795151 20.1422602,30.1936945 16,30.2100004 C10.6314928,30.2111903 5.71925925,27.1909327 3.29727884,22.3998074 C0.87529843,17.6086821 1.35586763,11.8622878 4.54,7.54 C7.22057338,3.89583814 11.4761331,1.74577784 16,1.74999379 L16,1.74999379 Z M16,0.449778431 C15.2097442,0.445632755 14.4204524,0.505832979 13.64,0.63 C5.61524107,1.86253225 -0.105898158,9.06817395 0.512780538,17.1634274 C1.13145923,25.2586808 7.88113986,31.5112418 16,31.51 C16.7900562,31.5089765 17.5789273,31.4488084 18.36,31.33 C26.3847589,30.0974678 32.1058982,22.891826 31.4872195,14.7965726 C30.8685408,6.70131917 24.1188601,0.448758249 16,0.449778431 Z" id="Shape" fill="#4E4C4A" fillRule="nonzero"></path>
                                                        <path d="M15.85,12.69 L15.85,23.18" id="Path" stroke="#4E4C4A" strokeWidth="1.3"></path>
                                                        <path d="M15.85,8.89 L15.85,10.62" id="Path" stroke="#4E4C4A" strokeWidth="1.3"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                        </Popover>
                                    </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default ImpactSection;